<template>
  <div id="shop">
    <section id="stage">
      <v-img
        src="../assets/stage/stage_sonnenblume.jpg"
        lazy-src="../assets/stage/80/stage_sonnenblume.jpg"
        :height="this.$vuetify.breakpoint.height / 2.4"
      />
    </section>

    <v-container>
      <v-row>
        <v-col sm="12" lg="10" offset-lg="1" xl="8" offset-xl="2" class="pb-0">
          <h2 class="greend--text">Online-Shop</h2>
          <ProductDisplay />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import ProductDisplay from "../components/shop/ProductDisplay";

export default {
  name: "shop",

  components: {
    ProductDisplay
  },
  mounted() {
    this.$vuetify.goTo(0);
  }
};
</script>

<style scoped></style>
